import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { TemperatureWidget } from './TemperatureWidget'

class HoldstyringTemperatureElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return TemperatureWidget
  }

  // Supported HTML attributes:
  //   title="Temperatur lige nu"   — small label in front of the readings (default: none)
  //   variant="ocean|dark|light"   — colour scheme (default: ocean)
  //   show-last-updated="false"    — hide the "Opdateret" line + refresh button (default: visible)
  //   latitude / longitude         — badested-koordinater. Er de sat, hentes
  //                                  hav-/lufttemp fra offentlig data (Open-Meteo)
  //                                  i stedet for tenantens Thermit-sensor.
  protected getWidgetProps() {
    const variant = this.getAttribute('variant')
    return {
      title: this.getAttribute('title') || null,
      variant: variant === 'dark' || variant === 'light' ? variant : 'ocean',
      showLastUpdated: this.getAttribute('show-last-updated') !== 'false',
      latitude: this.getAttribute('latitude'),
      longitude: this.getAttribute('longitude'),
    }
  }
}

if (!customElements.get('holdstyring-temperature')) {
  customElements.define('holdstyring-temperature', HoldstyringTemperatureElement)
}

export { HoldstyringTemperatureElement }
